import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

export default function AcilDurumEgitimleriPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    
    // SEO Meta Tags
    document.title = 'Acil Durum Eğitimleri | Adana OSGB Mersin Hatay Osmaniye | ASSA Akademi';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adana acil durum eğitimi, Mersin acil durum eğitimi, Hatay acil durum eğitimi, Osmaniye acil durum eğitimi. ASSA Akademi deprem, yangın, tahliye hazırlık ve müdahale eğitimi.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adana acil durum eğitimi, Mersin acil durum eğitimi, Hatay acil durum eğitimi, Osmaniye acil durum eğitimi, deprem eğitimi, tahliye eğitimi');
    }

    // Canonical URL
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://www.assaosgb.com.tr/egitimler/acil-durum-egitimleri');
    }

    // Schema.org JSON-LD
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "Acil Durum Eğitimleri",
      "description": "Adana, Mersin, Hatay, Osmaniye bölgelerinde ASSA Akademi acil durum hazırlık ve müdahale eğitimi.",
      "provider": {
        "@type": "Organization",
        "name": "ASSA Akademi",
        "telephone": "+90-850-346-2772"
      },
      "areaServed": ["Adana", "Mersin", "Hatay", "Osmaniye"],
      "url": "https://www.assaosgb.com.tr/egitimler/acil-durum-egitimleri"
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-purple-600 to-purple-800 text-white py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Acil Durum Eğitimleri</h1>
            <p className="text-xl md:text-2xl mb-8 text-purple-100">
              ASSA Akademi ile Acil Durum Hazırlık ve Müdahale Eğitimi
            </p>
            <div className="flex flex-wrap justify-center gap-4 text-lg">
              <span className="bg-white/20 px-4 py-2 rounded-full">Adana Acil Durum</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Mersin Acil Durum</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Hatay Acil Durum</span>
              <span className="bg-white/20 px-4 py-2 rounded-full">Osmaniye Acil Durum</span>
            </div>
          </div>
        </div>
      </section>

      {/* ASSA Akademi Section */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">ASSA Akademi</h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Adana, Mersin, Hatay ve Osmaniye illerinde acil durum yönetimi konusunda 
              uzmanlaşmış ASSA Akademi, kapsamlı eğitimlerle acil durumlara hazırlık sağlar.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <img 
                src="https://public.readdy.ai/ai/img_res/aea19fee2843474e9f13336c2ed23999.jpg"
                alt="ASSA Akademi Acil Durum Eğitimi"
                className="w-full h-80 object-cover rounded-lg shadow-lg"
              />
            </div>
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-alarm-warning-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Senaryo Bazlı Eğitim</h3>
                  <p className="text-gray-600">Gerçek acil durum senaryoları ile uygulamalı eğitimler</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-team-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">Ekip Koordinasyonu</h3>
                  <p className="text-gray-600">Acil durumlarda etkili ekip çalışması ve koordinasyon</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">İletişim Protokolleri</h3>
                  <p className="text-gray-600">Acil durum iletişim sistemleri ve bildirim prosedürleri</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Eğitim İçeriği */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Acil Durum Eğitimi İçeriği</h2>
            <p className="text-lg text-gray-600">Kapsamlı acil durum hazırlık eğitimi programımız</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-earthquake-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Doğal Afetler</h3>
              <p className="text-gray-600">Deprem, sel, fırtına gibi doğal afetlere hazırlık ve müdahale</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-run-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Tahliye Prosedürleri</h3>
              <p className="text-gray-600">Güvenli ve hızlı tahliye planları ve uygulamaları</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-first-aid-kit-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Acil Tıbbi Müdahale</h3>
              <p className="text-gray-600">Acil durumlarda temel tıbbi müdahale teknikleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-shield-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Güvenlik Protokolleri</h3>
              <p className="text-gray-600">Acil durum güvenlik önlemleri ve koruma stratejileri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-radio-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">İletişim Sistemleri</h3>
              <p className="text-gray-600">Acil durum iletişim araçları ve kullanım teknikleri</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg border border-gray-100">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-file-list-line text-purple-600 text-xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Acil Durum Planları</h3>
              <p className="text-gray-600">Acil durum planlarının hazırlanması ve uygulanması</p>
            </div>
          </div>
        </div>
      </section>

      {/* Şehirler */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-4">Hizmet Verdiğimiz İller</h2>
            <p className="text-lg text-gray-600">ASSA Akademi Acil Durum Eğitimleri</p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-alarm-warning-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Adana</h3>
              <p className="text-gray-600">Adana Acil Durum Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-alarm-warning-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Mersin</h3>
              <p className="text-gray-600">Mersin Acil Durum Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-alarm-warning-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Hatay</h3>
              <p className="text-gray-600">Hatay Acil Durum Eğitimi</p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-lg text-center">
              <div className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-alarm-warning-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">Osmaniye</h3>
              <p className="text-gray-600">Osmaniye Acil Durum Eğitimi</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Acil Durum Eğitimi Almak İster misiniz?</h2>
          <p className="text-xl text-purple-100 mb-8">
            ASSA Akademi ile acil durumlara hazırlıklı olun
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim" 
              className="bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap"
            >
              Bilgi Al
            </Link>
            <a 
              href="tel:08503462772" 
              className="bg-purple-700 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-800 transition-colors whitespace-nowrap"
            >
              Hemen Ara
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
}
